import { memo } from 'react';
import {
  setComma,
  classNameBind,
} from '@wconcept/wconcept-common/utils/commonUtils';
import Button from '@wconcept/wconcept-ui-renewal/components/atoms/Button';
import Text from '@wconcept/wconcept-ui-renewal/components/atoms/Text';
import * as S from './style';

interface IProps {
  text?: string;
  cnt?: number;
  onClick?: () => void;
}

const FltDptCategoryItem = ({ text = '', cnt, onClick }: IProps) => {
  const cName = classNameBind(['filter-depth-category item']);

  return (
    <S.FltDptCategoryItem className={cName}>
      <Button onClick={onClick} className="btn-text">
        <Text>{text}</Text>
        {cnt !== undefined && (
          <Text className="cnt">{setComma(String(cnt))}</Text>
        )}
      </Button>
    </S.FltDptCategoryItem>
  );
};

export default memo(FltDptCategoryItem);
